import { ServiceBase, Result, PagedResult, Sorting } from "./ServiceBase";
import { ProductAttribute } from '../models/ProductAttribute';

export class SearchIn {

    keywords: string;
    sorting: Sorting;

    constructor() {
        this.keywords = '';
        this.sorting = new Sorting();
    }

    public static fromInput(input: Partial<SearchIn>) {
        var result = new SearchIn();
        result = { ...result, ...input };
        return result;
    }
}

export default class ProductAttributeService extends ServiceBase {

    public static async listByProductId(productId: string): Promise<Result<ProductAttribute[]>> {

        var result = await this.requestJson<ProductAttribute[]>({
            url: `/api/ProductAttribute/listByProductId/${productId}`,
            method: "GET"            
        });

        return result;
    }

    public static async resetOrderByProductId(productId: string): Promise<Result<ProductAttribute[]>> {

        var result = await this.requestJson<ProductAttribute[]>({
            url: `/api/ProductAttribute/resetorder/${productId}`,
            method: "GET"
        });

        return result;
    }

    public static async search(filters: SearchIn, offset: number, pageSize: number): Promise<Result<PagedResult<ProductAttribute>>> {

        let payload = { ...filters, pageSize, offset };

        var result = await this.requestJson<PagedResult<ProductAttribute>>({
            url: `/api/ProductAttribute/search`,
            method: "POST",
            data: payload
        });

        return result;
    }

    public static async get(id: string): Promise<Result<ProductAttribute>> {

        var result = await this.requestJson<ProductAttribute>({
            url: `/api/ProductAttribute/${id}`,
            method: "GET"
        });
        return result;
    }

    public static async save(model: ProductAttribute): Promise<Result<ProductAttribute>> {

        var result = await this.requestJson<ProductAttribute>({
            url: `/api/ProductAttribute/save`,
            method: "POST",
            data: model
        });

        if (!result.hasErrors) {

            result = await ProductAttributeService.get(model.Id);
        }

        return result;
    }

    public static async delete(codeId: Number): Promise<Result<ProductAttribute>> {
        var result = await this.requestJson<ProductAttribute>({
            url: `/api/ProductAttribute/${codeId}`,
            method: "DELETE"
        });
        return result;
    }
}
